import { useMutation } from 'react-query';
import { apiRequest } from '../services/api';
import config from '../config';

const calculateDevelopment = async (params) => {
  const {
    postcode,
    purchasePrice,
    sqftPreDevelopment,
    sqftPostDevelopment,
    projectType = 'refurbish',
    finishQuality = 'medium',
  } = params;
  if (!postcode || !purchasePrice || !sqftPreDevelopment || !sqftPostDevelopment) {
    throw new Error('All fields are required');
  }

  const cacheKey = `dev_calc_${postcode}_${purchasePrice}_${sqftPreDevelopment}_${sqftPostDevelopment}_${projectType}_${finishQuality}`;
  const cacheDuration = 12 * 60 * 60 * 1000;
  const queryParams = {
    postcode,
    purchase_price: purchasePrice,
    sqft_pre_development: sqftPreDevelopment,
    sqft_post_development: sqftPostDevelopment,
    project_type: projectType,
    finish_quality: finishQuality,
  };
  const queryString = Object.entries(queryParams)
    .map(([key, value]) => `${encodeURIComponent(key)}=${encodeURIComponent(value)}`)
    .join('&');
  const url = `${config.apiUrl}/property-data/development-calculator?${queryString}`;
  const responseData = await apiRequest(url, {});

  if (responseData.success) {
    return responseData.data;
  } else {
    throw new Error(responseData.message || 'Failed to fetch development calculator data');
  }
};

const useDevelopmentCalculator = () => {
  const mutation = useMutation(calculateDevelopment);
  return mutation;
};

export default useDevelopmentCalculator;
